import request from '@/utils/request'

const BASE_URL = '/config'

/**
 * 医院名称检索
 */
export function searchHospital(
  data = {
    name: '',
    province: '',
    year: 0,
    code: ''
  }
) {
  return request({
    url: `${BASE_URL}/hospital/search`,
    method: 'POST',
    data
  })
}

/**
 * 医学院名称检索
 */
export function searchCollege(
  data = {
    name: '',
    province: '',
    year: 0
  }
) {
  return request({
    url: `${BASE_URL}/university/search`,
    method: 'POST',
    data
  })
}

/**
 * 国际医院名称检索
 * @param {*} data
 * @returns
 */
export function searchInternationalHospital(
  data = {
    name: '',
    country: '',
    year: 0
  }
) {
  return request({
    url: `${BASE_URL}/all/search`,
    method: 'POST',
    data
  })
}

/**
 * 年份列表
 */
export function listYear() {
  return request({
    url: `${BASE_URL}/year/list`,
    method: 'post'
  })
}

/**
 * 学科列表
 */
export function listSubject() {
  return request({
    url: `${BASE_URL}/subject/menu`,
    method: 'post'
  })
}

/**
 * uv统计
 */
export function countUV() {
  return request({
    url: `${BASE_URL}/uv`,
    method: 'post'
  })
}

/**
 * uv统计
 */
export function setPV() {
  return request({
    url: `${BASE_URL}/setPV`,
    method: 'post'
  })
}

/**
 * 页面访问量统计
 */
export function countPV() {
  return request({
    url: `${BASE_URL}/pv`,
    method: 'post'
  })
}
